module.exports = __webpack_public_path__ + "static/media/gd-report.abd5c413.pdf";